import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { EngagementEditInput } from '../../models/engagement-edit-input.model';
import { EngagementStatus } from '../../models/engagement-status.model';
import { Nomination } from '../../models/nomination.model';
import { SelectCustomer } from '../../models/select-customer.model';
import { SelectUsageByPartner } from '../../models/select-usage-by-partner.model';
import { ValidateUsageEngagement } from '../../models/validate-usage-engagement.model';
import { SettingsService } from '../common/settings.service';
import { CommonSharedModule } from '../common/shared.module';
import { EditComponent } from '../home/edit/edit.component';
import { CustomerUsageService } from '../services/customer-usage.service';
import { LocalStorageService } from '../services/local-storage-service';
import { SearchCustomerComponent } from './search-customer/search-customer.component';

@Component({
  selector: 'app-customer-usage',
  templateUrl: './customer-usage.component.html',
  styleUrls: ['./customer-usage.component.scss'],
  standalone: true,
  providers: [],
  imports: [CommonSharedModule, EditComponent, SearchCustomerComponent]
})
export class CustomerUsageComponent implements OnInit {
  loadCustomerSearch = false;
  loadTenantInfo = false;
  showFullscreen = true;

  engagementStatus!: EngagementStatus[];
  eligibleEngagements!: ValidateUsageEngagement[];
  inEligibleEngagements!: ValidateUsageEngagement[];
  selectUsageByPartners!: SelectUsageByPartner[];
  allNominations!: Nomination[];
  selectedCustomer!: SelectCustomer[];
  selCustomer: any;
  cols!: any[];
  selectedItem!: ValidateUsageEngagement;

  loadEditComponent = false;
  editNav = false;
  requestDetailId!: number;
  engagementIdPassToChild!: number;
  engagementEditInput!: EngagementEditInput;

  tId!: string;
  loading = false;
  showResult = false;
  loadingIcon = 'fa-circle-o-notch';
  isLoading = false;

  @ViewChild('editNavChild', { static: false }) editNavChild!: EditComponent;

  constructor(
    public settings: SettingsService,
    private router: Router,
    private service: CustomerUsageService,
    public localStorage: LocalStorageService
  ) { }

  customerSearch() {
    this.loadCustomerSearch = true;
  }

  cancelSearchNav() {
    this.loadCustomerSearch = false;
  }

  cancelTenantInfo() {
    this.loadTenantInfo = false;
  }

  tenantInfo() {
    this.loadTenantInfo = true;
  }

  @HostListener('window:resize') onresize(): void {
    requestAnimationFrame(() => {
      const editEngagement = document
        ?.querySelector('#engagementEdit')
        ?.querySelector<HTMLElement>('[role="dialog"]');

      if (editEngagement) {
        editEngagement.style.width = '90%';
        editEngagement.style.height = '85%';
      }
    });
  }

  ngOnInit() {
    this.showResult = false;
    this.loadCustomerSearch = false;
    this.loadTenantInfo = false;
    this.showFullscreen = this.localStorage.getFullscreenMode();

    if (this.engagementEditInput) {
      this.engagementEditInput = {
        showFullScreen: this.showFullscreen
      } as any;
    }
  }

  editRequestDetails(event, id: number) {
    this.loadEditComponent = true;
    this.editNav = true;
    this.requestDetailId = id;
    this.engagementIdPassToChild = id;
    this.engagementEditInput = {
      ...this.engagementEditInput,
      engagementId: id
    };

    if (this.editNavChild) {
      this.editNavChild.fillEditValues(id);
    }
  }

  redirectToPartner(partnerMpnId: string) {
    this.router.navigate(['/partner-dashboard'], {
      queryParams: {
        mpnId: partnerMpnId
      }
    });
  }

  selectedTiD(event: any) {
    this.selCustomer = event;
    this.tId = event.tenantId;
    this.showResult = true;

    if (this.settings.AliasName) {
      this.service
        .searchCustomer(this.tId, this.settings.AliasName)
        .subscribe(messageResponse => {
          this.selectedCustomer = messageResponse;
        });

      this.service
        .getAllEngagements(this.tId, this.settings.AliasName)
        .subscribe(eligibleEngs => {
          this.eligibleEngagements = eligibleEngs.filter(
            x => x.isEligible === 1
          );
        });

      this.service
        .getAllEngagements(this.tId, this.settings.AliasName)
        .subscribe(inEligibleEngs => {
          this.inEligibleEngagements = inEligibleEngs.filter(
            x => x.isEligible === 0
          );
        });

      this.service
        .getEligibleEngagementStatus(this.tId, this.settings.AliasName)
        .subscribe(eligibleEngStatus => {
          this.engagementStatus = eligibleEngStatus;
        });

      this.service
        .getSelectUsageByPartner(this.tId, this.settings.AliasName)
        .subscribe(partnerlist => {
          this.selectUsageByPartners = partnerlist;
        });

      this.service
        .getAllNominations(this.tId, this.settings.AliasName)
        .subscribe(nominationlist => {
          this.allNominations = nominationlist;
        });
    }
  }

  onShowFullScreenChanged(showFullscreenValue: boolean) {
    this.showFullscreen = showFullscreenValue;
    this.localStorage.setFullscreenMode(this.showFullscreen);
  }

  onCloseEditModal() {
    this.loadEditComponent = false;
    this.editNav = false;
  }

  onLoading(isLoading: boolean) {
    this.isLoading = isLoading;
  }
}
